module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-container"
  }, [_c('m-header', [_c('div', {
    attrs: {
      "slot": "nav"
    },
    slot: "nav"
  })]), _vm._v(" "), _c('div', {
    staticClass: "w"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-sidebar"
  }, [_c('div', {
    staticClass: "avatar gray-box",
    staticStyle: {
      "margin-bottom": "10px",
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "border-radius": "5px"
    },
    attrs: {
      "src": _vm.user.avatar == '' ? '/static/images/default.png' : _vm.user.avatar
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "gray-box"
  }, [_c('el-menu', {
    ref: "sideMenu",
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.activeIndex
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_vm._l((_vm.navMenuData), function(item) {
    return _c('div', {
      key: item.index
    }, [(!item.child && item.index == 'desOrderList') ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      }
    }, [_c('i', {
      staticClass: "el-icon-menu"
    }), _vm._v("1" + _vm._s(item.name))]) : _vm._e(), _vm._v(" "), (!item.child && item.index == 'orderList') ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      }
    }, [_c('i', {
      staticClass: "el-icon-s-order"
    }), _vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (!item.child && item.index == 'addressList') ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      }
    }, [_c('i', {
      staticClass: "el-icon-position"
    }), _vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (!item.child && item.index == 'invoice') ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      }
    }, [_c('i', {
      staticClass: "el-icon-postcard"
    }), _vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (!item.child && item.index == 'support') ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    }), _vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (!item.child && item.index == 'out') ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      }
    }, [_c('i', {
      staticClass: "el-icon-remove"
    }), _vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (item.child && item.index === 'designer' && _vm.user.userType === '10') ? _c('el-submenu', {
      attrs: {
        "index": item.index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.child), function(item2) {
      return _c('div', {
        key: item2.index
      }, [_c('el-menu-item', {
        attrs: {
          "index": item2.index
        }
      }, [_vm._v(_vm._s(item2.name))])], 1)
    })], 2) : _vm._e(), _vm._v(" "), (item.child && item.index != 'designer') ? _c('el-submenu', {
      attrs: {
        "index": item.index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      staticClass: "el-icon-user"
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.child), function(item2) {
      return _c('div', {
        key: item2.index
      }, [_c('el-menu-item', {
        attrs: {
          "index": item2.index
        }
      }, [_vm._v(_vm._s(item2.name))])], 1)
    })], 2) : _vm._e()], 1)
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "account-content"
  }, [_c('router-view')], 1)])]), _vm._v(" "), _c('m-footer'), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "label label-default"
  }, [_c('i', {
    staticClass: "el-icon-s-custom"
  }), _vm._v(" 认证用户")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b75b50b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/User/user.vue
// module id = 667
// module chunks = 0